'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  logging: {
    SET_CONTEXT: 'SET_CONTEXT',
    LOG_ERROR: 'LOG_ERROR'
  }
};